export default "__VITE_ASSET__BBSVGbqU__"